module.exports = __webpack_public_path__ + "img/3.3a76a21c.jpg";